import React, { FC } from 'react'
import { Text, useDate } from '@afterpaytouch/core'
import { useTranslation } from '../../../../../utils/convergence'
import { useAppRouter } from '../../../../../state'
import { CheckoutPaymentSchedule } from '@afterpaytouch/portal-api'

type TimelineTitleProps = {
  paymentNumber: number
  paymentSchedule: CheckoutPaymentSchedule
  numberOfInstallments: number
  testNameSpace?: string
}

export const TimelineTitle: FC<TimelineTitleProps> = ({ paymentNumber, paymentSchedule, numberOfInstallments, testNameSpace }): JSX.Element => {
  const { t } = useTranslation(['summary'])
  const { locale } = useAppRouter()
  const { formatDate } = useDate({ locale, weekday: 'short' })

  if (paymentSchedule.installmentDueDate) {
    return (
      <>
        <Text size='S' bold testNameSpace={`${testNameSpace}-date`}>
          {formatDate(paymentSchedule.installmentDueDate)}
        </Text>
        <Text size='XS' color='Gray50' renderAs='span' testNameSpace={testNameSpace}>
          {t('appleRetail.paymentXofY', {
            paymentNumber,
            totalPayments: numberOfInstallments,
          })}
        </Text>
      </>
    )
  }

  return (
    <Text size='S' bold renderAs='span' testNameSpace={testNameSpace}>
      {t('appleRetail.paymentXofY', {
        paymentNumber,
        totalPayments: numberOfInstallments,
      })}
    </Text>
  )
}
